import { uploadFileMeta, uploadFileBlob } from '../thunks/upload';
import { cancelAllUploads, cancelUploadById } from '../thunks/cancel-upload';

export const uploadReducers = (builder) => {
  // Upload file authorize (set files to imported files if not already exist in the importedFiles array)
  builder
    .addCase(uploadFileMeta.fulfilled, (state, action) => {
      const fileId = action.payload.id;
      const metaData = action.payload.data;
      const fileType = action.payload.type;
      const { id: backendId, ...metaDataWithoutId } = metaData;

      const importedFiles = [...state.importedFiles];
      const fileIndex = importedFiles.findIndex((item) => item.id === fileId);

      if (fileIndex !== -1) {
        importedFiles[fileIndex] = {
          ...importedFiles[fileIndex],
          ...metaDataWithoutId,
          backendId,
          content_type: fileType,
        };
        state.importedFiles = importedFiles;
      }
    })
    .addCase(uploadFileMeta.rejected, (state, action) => {
      const fileId = action.payload;
      const importedFiles = [...state.importedFiles];
      const fileIndex = importedFiles.findIndex((item) => item.id === fileId);
      if (fileIndex !== -1) {
        if (importedFiles[fileIndex].status !== 'cancelled') {
          importedFiles[fileIndex] = { ...importedFiles[fileIndex], status: 'rejected' };
        }
        state.importedFiles = importedFiles;
      }
    });

  // Upload file content
  builder
    .addCase(uploadFileBlob.fulfilled, (state, action) => {
      const fileId = action.payload.id;
      const importedFiles = [...state.importedFiles];
      const fileIndex = importedFiles.findIndex((item) => item.id === fileId);

      if (fileIndex === -1) {
        return;
      }

      if (importedFiles[fileIndex].status === 'cancelled') {
        state.importedFiles = importedFiles;
        return;
      }

      importedFiles[fileIndex] = { ...importedFiles[fileIndex], status: 'fulfilled' };
      state.importedFiles = importedFiles;
      const items = [...state.items.value];
      items.unshift({
        ...importedFiles[fileIndex],
        name: importedFiles[fileIndex].fileName,
      });
      state.items.value = items;
    })
    .addCase(uploadFileBlob.rejected, (state, action) => {
      const fileId = action.payload;
      const importedFiles = [...state.importedFiles];
      const fileIndex = importedFiles.findIndex((item) => item.id === fileId);
      if (fileIndex !== -1) {
        if (importedFiles[fileIndex].status !== 'cancelled') {
          importedFiles[fileIndex] = { ...importedFiles[fileIndex], status: 'rejected' };
        }
        state.importedFiles = importedFiles;
      }
    });

  builder
    .addCase(cancelUploadById.fulfilled, (state, action) => {
      const fileId = action.payload;
      const importedFiles = [...state.importedFiles];
      const fileIndex = importedFiles.findIndex((item) => item.id === fileId);
      let cancelledFile = null;

      if (fileIndex !== -1 && importedFiles[fileIndex].status === 'pending') {
        importedFiles[fileIndex] = { ...importedFiles[fileIndex], status: 'cancelled' };
        state.importedFiles = importedFiles;
        cancelledFile = importedFiles[fileIndex];
      }

      if (cancelledFile) {
        const cancelledIds = [cancelledFile.id, cancelledFile.backendId, cancelledFile.oid].filter(Boolean);
        const cancelledSet = new Set(cancelledIds);

        state.items.value = state.items.value.filter(
          (item) => !cancelledSet.has(item.id) && !cancelledSet.has(item.backendId) && !cancelledSet.has(item.oid)
        );
      }
    })
    .addCase(cancelAllUploads.fulfilled, (state) => {
      const cancelledIds = [];

      const importedFiles = state.importedFiles.map((item) => {
        if (item.status === 'pending') {
          cancelledIds.push(item.id);
          if (item.backendId) {
            cancelledIds.push(item.backendId);
          }
          if (item.oid) {
            cancelledIds.push(item.oid);
          }

          return { ...item, status: 'cancelled' };
        }

        return item;
      });

      state.importedFiles = importedFiles;

      if (cancelledIds.length > 0) {
        const cancelledSet = new Set(cancelledIds);
        state.items.value = state.items.value.filter(
          (item) => !cancelledSet.has(item.id) && !cancelledSet.has(item.backendId) && !cancelledSet.has(item.oid)
        );
      }
    });

  // Upload file sync
  // builder
  //   .addCase(uploadFileRefresh.rejected, (state, action) => {
  //     const fileId = action.payload;
  //     const importedFiles = [...state.importedFiles];
  //     const fileIndex = importedFiles.findIndex((item) => item.id === fileId);
  //     if (fileIndex !== -1) {
  //       importedFiles[fileIndex] = { ...importedFiles[fileIndex], status: 'rejected' };
  //       state.importedFiles = importedFiles;
  //     }
  //   })
  //   .addCase(uploadFileRefresh.fulfilled, (state, action) => {
  //     const { id, data } = action.payload;
  //     const importedFiles = [...state.importedFiles];
  //     const fileIndex = importedFiles.findIndex((item) => item.id === id);
  //     if (fileIndex !== -1) {
  //       importedFiles[fileIndex] = { ...importedFiles[fileIndex], status: 'fulfilled' };
  //       state.importedFiles = importedFiles;
  //     }
  //     const items = [...state.items.value];
  //     items.push(data);
  //     state.items.value = items;
  //   });
};
